export default __webpack_public_path__ + "static/payment-gatway-f301d9bb02246ed5f98b203a25ae4a68.png";